"use client";
import { AuthLink } from "@/components/shared/auth-link";
import { TrackedLink } from "@/components/shared/tracked-link";
import { useAppConfig } from "@/lib/config";

import { Button } from "@meetploy/storybook";

export default function CallToAction() {
	const config = useAppConfig();
	return (
		<section className="border-t border-border py-24">
			<div className="container mx-auto px-4">
				<div className="mx-auto max-w-3xl text-center">
					<p className="mb-4 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
						Get started
					</p>
					<h2 className="mb-6 text-3xl font-bold tracking-tight md:text-4xl">
						Your agents shouldn&apos;t live on someone else&apos;s black box
					</h2>
					<p className="mb-10 text-lg leading-relaxed text-muted-foreground">
						Deploy in minutes on our cloud, or run the whole platform on your
						own infrastructure. Same code, same primitives, no lock-in.
					</p>

					<div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
						<Button
							size="lg"
							className="w-full sm:w-auto"
							render={
								<AuthLink
									href="/signup"
									ctaId="deploy_first_agent"
									ctaLocation="cta_section"
									ctaText="Deploy your first agent"
								/>
							}
						>
							Deploy your first agent
						</Button>
						<Button
							size="lg"
							variant="outline"
							className="w-full sm:w-auto"
							render={
								<TrackedLink
									href={config.githubUrl ?? ""}
									location="cta_section"
									destination="github"
									linkText="Self-host Ploy"
									target="_blank"
								/>
							}
						>
							Self-host Ploy
						</Button>
					</div>
				</div>
			</div>
		</section>
	);
}
